import { SET_USER_GAME_INFO } from '../actionTypes';

const initialState = {
  results: null,
  careers: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_USER_GAME_INFO: {
      const { results, careers } = action.payload;

      return {
        ...state,
        results,
        careers,
      };
    }

    default:
      return state;
  }
}
